import { Box, Paragraph } from '@zillow/constellation-10';

const ConfirmMarkPaidPage = () => (
  <Box css={{ display: 'flex', flexDirection: 'column', gap: 'token(spacing.sm)' }}>
    <Paragraph>The change will be recorded on both your dashboard and your landlord&apos;s.</Paragraph>
  </Box>
);

export default ConfirmMarkPaidPage;
